import { useSelector } from "react-redux";
import Product from "./Product";

export function ShowProduct() {
  const productList = useSelector((state) => state);

  return (
    <div className="productContainer" id="lws-productContainer">
      {productList.length !== 0
        ? productList.map((product) => (
            <Product key={product.id} product={product} />
          ))
        : "No Product Found"}
    </div>
  );
}
